"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const services_1 = require("@zapier/services");
const common_utils_1 = require("@zapier/common-utils");
const generateZapTitleFromActions = ({ query, services }) => {
    if (!query ||
        !query.headActionLabel ||
        !query.tailActionLabel ||
        lodash_1.default.isEmpty(services)) {
        return '';
    }
    const { headServiceId, headActionLabel, tailServiceId, tailActionLabel, } = query;
    const headActionAppName = (services_1.utils.getServiceByKey(services, headServiceId) || {}).name || '';
    const tailActionAppName = (services_1.utils.getServiceByKey(services, tailServiceId) || {}).name || '';
    if (headServiceId === tailServiceId) {
        return `${lodash_1.default.upperFirst(common_utils_1.toLowerCaseString(tailActionLabel))} in ${headActionAppName} when ${common_utils_1.toLowerCaseString(headActionLabel)}`;
    }
    return `${lodash_1.default.upperFirst(common_utils_1.toLowerCaseString(tailActionLabel))} in ${tailActionAppName} when ${common_utils_1.toLowerCaseString(headActionLabel)} in ${headActionAppName}`;
};
exports.default = generateZapTitleFromActions;
